<div id="sh-app-access-container-div" *transloco="let t">
	<img id="sh-app-access-no-apps-img" [src]="'assets/images/ignite-no-apps.svg' | version | async" />
	<div id="sh-app-access-sub-title-head-div">{{ t('cloud.shure-cloud.no-apps-content.subtitle-head') }}</div>
	<div id="sh-app-access-sub-title-text-div">{{ t('cloud.shure-cloud.no-apps-content.subtitle-text') }}</div>
</div>
